'use client'

import React, { useEffect, useState } from 'react'

import { Box } from '@hanzo/ui'
import { useIam } from '@hanzo/iam/react'

import { resume } from './resume'

  /**
   * The site's OAuth redirect target. IAM sends the authorization code here and
   * this redeems it for tokens with the PKCE verifier the browser kept, then
   * returns the visitor to the page they left.
   */
const Callback = () => {

  const { handleCallback } = useIam()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    handleCallback()
      .then(() => { window.location.replace(resume()) })
      .catch((e: Error) => { setError(e.message) })
      /* Runs once: the authorization code is single-use. */
  }, [])

  return (
    <Box tag="main" className='flex min-h-screen items-center justify-center p-8 text-center'>
      {error ? (
        <Box className='flex flex-col gap-4'>
          <p role='alert'>{error}</p>
          <Box tag="a" href='/' className='underline'>Back to the site</Box>
        </Box>
      ) : (
        <p>Signing you in…</p>
      )}
    </Box>
  )
}

export default Callback
